import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { withThemeVariant } from '../../provider/ThemeProvider/index';
import styles from './style.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A headline component providing styled h1, h2, h3 or h4 headline elements
 *
 * @param	{1|2|3|4}	size			The headlines hierarchy (h1 to h4)
 * @param	{string}	color			A css conform hex/rgb/rgba color code
 * @param	{boolean}	noMargin	Wether or not to render the componentn with margin
 * @param	{boolean}	center		Wether or not to center the content
 * @param	{string}	textAlign	The headings text align
 * @param	{boolean}	pseudo	  Wether or not to render as a real HTML heading element
 * @param	{content}	children	The headlines content
 **/

var Headline = function Headline(_ref) {
  var size = _ref.size,
    children = _ref.children,
    color = _ref.color,
    _ref$noMargin = _ref.noMargin,
    noMargin = _ref$noMargin === void 0 ? false : _ref$noMargin,
    _ref$center = _ref.center,
    center = _ref$center === void 0 ? false : _ref$center,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'left' : _ref$textAlign,
    _ref$pseudo = _ref.pseudo,
    pseudo = _ref$pseudo === void 0 ? false : _ref$pseudo,
    globalThemeVariant = _ref.globalThemeVariant,
    globalThemeSubVariant = _ref.globalThemeSubVariant,
    className = _ref.className,
    displayAs = _ref.displayAs,
    _ref$important = _ref.important,
    important = _ref$important === void 0 ? false : _ref$important;
  // "Legacy" support
  textAlign = center ? 'center' : textAlign;
  var combinedClassName = "\n  ".concat(styles['heading' + (displayAs || size)], " ").concat(important ? styles.important : '', " ").concat(styles[globalThemeVariant], " ").concat(styles[globalThemeSubVariant], " ").concat(noMargin && styles.noMargin, " ").concat(className, "\n    ");
  var Base = function Base(props) {
    return pseudo ? /*#__PURE__*/_jsx("div", {
      className: combinedClassName,
      children: children
    }) : size === 1 ? /*#__PURE__*/_jsx("h1", _extends({
      className: combinedClassName
    }, props, {
      children: children
    })) : size === 2 ? /*#__PURE__*/_jsx("h2", _extends({
      className: combinedClassName
    }, props, {
      children: children
    })) : size === 3 ? /*#__PURE__*/_jsx("h3", _extends({
      className: combinedClassName
    }, props, {
      children: children
    })) : size === 4 ? /*#__PURE__*/_jsx("h4", _extends({
      className: combinedClassName
    }, props, {
      children: children
    })) : size === 5 ? /*#__PURE__*/_jsx("h5", _extends({
      className: combinedClassName
    }, props, {
      children: children
    })) : /*#__PURE__*/_jsx("div", _extends({
      className: combinedClassName
    }, props, {
      children: children
    }));
  };
  return /*#__PURE__*/_jsx(Base, {
    style: {
      color: color,
      textAlign: textAlign
    },
    children: children
  });
};
export default /*#__PURE__*/React.memo(withThemeVariant(Headline), function (prev, next) {
  return prev.children === next.children;
});